import React from 'react'
import USTemplateDefault from 'src/components/template/us'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      title="Switch to Fubo and save big"
      subtitle="Fubo has the live TV & sports you love for less than cable"
      highlightImage={'https://assets-imgx.fubo.tv/marketing/lp/images/posters/movers-v3.png'}
      highlightHeadline={'Move on from cable'}
      highlightSubtitle={
        'Live sports, top shows, local news and more. Get it all for less when you switch to Fubo. And you can start watching right away on all your devices.'
      }
      highlightCtaText={'Start for free'}
      hideNetworkSection={true}
    />
  )
}
